import { Document } from 'dashboard/models/document';
import Action from 'lib/interfaces/Action';

interface SetDocumentPayload {
  document: Document;
}

interface SetZoomScalePayload {
  zoomScale: number;
}

interface SetZoomVisualValuePayload {
  zoomVisualValue: string;
}

export type DocumentViewerActions =
  | Action<DocumentViewerActionType.ResetBaseState, Record<string, never>>
  | Action<DocumentViewerActionType.SetDocument, SetDocumentPayload>
  | Action<DocumentViewerActionType.RotateDocument, Record<string, never>>
  | Action<DocumentViewerActionType.SetZoomScale, SetZoomScalePayload>
  | Action<DocumentViewerActionType.IncrementZoomScale, Record<string, never>>
  | Action<DocumentViewerActionType.DecrementZoomScale, Record<string, never>>
  | Action<DocumentViewerActionType.SetZoomVisualValue, SetZoomVisualValuePayload>;

export enum DocumentViewerActionType {
  ResetBaseState = 'document-viewer/RESET_BASE_STATE',
  SetDocument = 'document-viewer/SET_DOCUMENT',
  RotateDocument = 'document-viewer/ROTATE_DOCUMENT',
  SetExtractionFilters = 'document-viewer/SET_EXTRACTION_FILTERS',
  SetZoomScale = 'document-viewer/SET_ZOOM_SCALE',
  IncrementZoomScale = 'document-viewer/INCREMENT_ZOOM_SCALE',
  DecrementZoomScale = 'document-viewer/DECREMENT_ZOOM_SCALE',
  SetZoomVisualValue = 'document-viewer/SET_ZOOM_VISUAL_VALUE',
}

export function resetBaseState() {
  return {
    type: DocumentViewerActionType.ResetBaseState,
  };
}

export function setDocument(document: Document) {
  return {
    payload: {
      document,
    },
    type: DocumentViewerActionType.SetDocument,
  };
}

export function rotateDocument() {
  return {
    type: DocumentViewerActionType.RotateDocument,
  };
}

export function setZoomScale(zoomScale: number) {
  return {
    payload: {
      zoomScale,
    },
    type: DocumentViewerActionType.SetZoomScale,
  };
}

export function incrementZoomScale() {
  return {
    payload: {},
    type: DocumentViewerActionType.IncrementZoomScale,
  };
}

export function decrementZoomScale() {
  return {
    payload: {},
    type: DocumentViewerActionType.DecrementZoomScale,
  };
}

export function setZoomVisualValue(zoomVisualValue: string) {
  return {
    payload: {
      zoomVisualValue,
    },
    type: DocumentViewerActionType.SetZoomVisualValue,
  };
}
